
<ng-template ssMobileToolbarContent>
    <div class="flex-1 flex-row flex--align-center">
        <button mat-icon-button (click)="back()"><mat-icon class="primary-contrast-text">arrow_back</mat-icon></button> 
        <h4 class="margin-none mat-headline-5 primary-contrast-text" > {{titleObs | async | translate}}</h4>
    </div>
</ng-template>

<mat-card class="full-height">

    <mat-card-header 
        *ngIf="!(isSmallerScreenObs | async)" 
        class="border-primary-bottom padding-standard flex-row flex--justify-between flex--align-center"
    >
        <mat-card-title class="mat-headline-4 margin-none">
            {{titleObs | async | translate}}
            <span class="primary-text-900">{{(remoteDataSubject |async)?.name}}</span>
        </mat-card-title>
        <button mat-icon-button (click)="back()"><mat-icon>close</mat-icon></button>
    </mat-card-header>

    <mat-card-content class="padding-standard flex-1" ssCoreLoaderOutlet [keys]="loaderKeys">

        <form *ngIf="mainFormGroupSubject | async" [formGroup]="mainFormGroupSubject | async" class="flex-column gap-standard">
 
            <ss-text-form-control class="col-width-large"  dataField="name" formControlName="name"></ss-text-form-control>

            <ss-multi-autocomplete-form-control 

                class="display-block col-width-large-2--fixed max-full-width"
                dataField="userIds" 
                formControlName="userIds"
                [loadFn]="loadFn"
                [displayExpr]="displayExprObs | async"
                [initialSelectedItems]="initialSelectedItemsObs | async"
            ></ss-multi-autocomplete-form-control>

        </form>

    </mat-card-content>

    <mat-card-footer class="border-primary-top ">
        
        <ss-crud-toolbar 
            [mode]="modeSubject | async"
            (save)="save()"
            (reset)="reset()"
            (delete)="delete()"
        ></ss-crud-toolbar>

    </mat-card-footer>

</mat-card>